export default {
  fonts: {
    poppins: "Poppins, -apple-system, BlinkMacSystemFont, Arial, sans-serif",
    karma: "Karma, -apple-system, BlinkMacSystemFont, Arial, sans-serif",
  },
  colors: {
    orange: "rgba(206,70,58,1)",
    blue: "rgb(38, 79, 149)",
    grey: "#778C9E",
    error: "#D32F2E",
    success: "#43a047",
    warning: "#ffa000",
  },
  breakpoints: {
    xl: "1280px",
    lg: "1024px",
    md: "768px",
    sm: "640px",
  },
};
